<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-01-08 09:28:52
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-04-21 16:27:37
 * @FilePath: \hxt-saas-pc\src\components\zsk.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template id="temp">
    <!-- vue实例外创建 -->
    <div class="box">
        <div class="content-wrapper">
            <div class="content-wrapper-top">
                <div class="active">智税宝</div>
                <div @click="laws">智能法规</div>
            </div>
            <div class="content-wrapper-buttom">
                <div class="kfz" v-if="!zdUrl">
                    <img src="@/assets/img/kfz.png" alt="">
                    <div>该功能正在开发，敬请期待！</div>
                </div>
                <div class="kfz1" v-else>
                    <iframe
                        style=" width: 100%;
                                                                                                                                                                                                                                                                                                                                                                                                            height: 700px;"
                        :src="zdUrl" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>
<!-- 调用   <mycom></mycom> -->
<script>
import { getSmartQAUrl } from '@/api/index';
export default {
    data() {
        return {
            zdUrl: "", token: ''
        }
    },
    created() {

        // if (this.$route.params.token) {
        //     this.token = this.$route.params.token

        // }
        // if (localStorage.getItem('token')) {
        //     this.token = localStorage.getItem('token');

        // }
        this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        this.getZdzx()
    },
    methods: {
        laws() {

            window.open("https://ai.taxyes.com/")
        }, getZdzx() {
            getSmartQAUrl({}, { Authorization: this.token }).then(res => {
                console.log("获取智达咨询信息", res)
                if (res.code == 0) {
                    this.zdUrl = res.data
                }
            })
        },
    }
}
</script>

<style scoped>
.box {
    width: 100%;
    background-color: #fff;
    margin: 5px auto;
    min-height: 800px;

}

.content-wrapper-top {
    background-color: #fff;
    width: 1200px;
    height: 60px;
    margin: 0 auto;
    display: flex;
}

.content-wrapper-top>div {
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    width: auto;
    color: #ccc;
    font-weight: 500;
    margin: 0 50px;
    cursor: pointer;
}

.content-wrapper-top>.active {
    color: #000;
}

.content-wrapper-top>div:hover {
    color: #000;
}

.content-wrapper-buttom {
    overflow: hidden;
    background-color: #fff;
    border-radius: 5px;
    height: 790px;

}

.kfz {

    width: 400px;
    height: 500px;
    margin: 0 auto;
    margin-top: 50px;
}

.kfz1 {
    width: 1400px;
    height: 790px;
    margin: 0 auto;
    margin-top: 5px;

}

.kfz>img {
    margin-left: 25px;
    width: 350px;
    height: 350px;
}

.kfz>div {
    height: 50px;
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 25px;
}
</style>